import { TargetingHomePageTakeOverType } from "scmp-app/components/advertisement/ad-slots/types";

export const SectionTopAdBannerConfigTemplate = {
  default: {
    desktopSizes: [
      [970, 250],
      [728, 90],
      [970, 90],
    ],
    extraTargeting: {},
    mobileSizes: [
      [300, 100],
      [320, 100],
      [300, 50],
      [320, 50],
    ],
  },
  style: {
    desktopSizes: [
      [970, 250],
      [1, 1],
      [480, 360],
      [480, 270],
    ],
    extraTargeting: { hpto: TargetingHomePageTakeOverType.Top },
    mobileSizes: [
      [300, 50],
      [300, 100],
      [320, 50],
      [320, 100],
    ],
  },
};
